var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              isDisabled: _vm.reqLoading,
              propsData: { isCurrency: true, isPayChannel: true }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _c(
            "el-col",
            {
              staticClass: "tipsClass",
              staticStyle: { position: "relative" },
              attrs: { span: 4 }
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.reqLoading,
                  clearable: "",
                  placeholder: _vm.$t("customRange")
                },
                model: {
                  value: _vm.searchData.self_design_day,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "self_design_day", $$v)
                  },
                  expression: "searchData.self_design_day"
                }
              }),
              _c(
                "el-tooltip",
                {
                  staticClass: "tipss",
                  attrs: { effect: "dark", placement: "top" }
                },
                [
                  _c("div", {
                    attrs: { slot: "content" },
                    domProps: { innerHTML: _vm._s(_vm.$t("customRangeTip")) },
                    slot: "content"
                  }),
                  _c("i", { staticClass: "el-icon-question " })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClickNs }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                }
              ],
              ref: "tableRef",
              attrs: {
                id: "tableRef",
                "cell-class-name": _vm.cellStyle,
                data: _vm.tableData,
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  fixed: "",
                  prop: "date",
                  "class-name": "font-bold",
                  label: _vm.$t("dateDotDate"),
                  "render-header": _vm.renderheader,
                  "min-width": _vm.$utils.flexColumnWidth("2020-01-01", true)
                }
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "recharge_all",
                  label: _vm.$t("rechargeAllDotEarnings"),
                  "sort-method": function(a, b) {},
                  "render-header": function(h, obj) {
                    return _vm.renderheader(h, obj, _vm.$t("rechargeAllDesc"))
                  },
                  "min-width": _vm.$utils.flexColumnWidth("内购纯收入A", true)
                }
              }),
              _vm.queryCurrency == "VND"
                ? _vm._l(_vm.exchangeVND, function(item, index) {
                    return _c("el-table-column", {
                      key: "desk" + item.prop,
                      attrs: {
                        sortable: "",
                        "sort-orders": ["descending", "ascending"],
                        "sort-method": function(a, b) {
                          return a[item.prop] - b[item.prop]
                        },
                        "class-name": item.classname,
                        prop: item.prop,
                        label: item.label,
                        "show-overflow-tooltip": "",
                        "render-header": function(h, obj) {
                          return _vm.renderheader(h, obj, item.desc)
                        },
                        "min-width": _vm.$utils.flexColumnWidth(
                          item.tabText,
                          true
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  " " + _vm._s(row.exchange || "0.00") + " "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "cost",
                  label: _vm.$t("costDotPay"),
                  "sort-method": function(a, b) {
                    return a.cost - b.cost
                  },
                  "render-header": _vm.renderheader,
                  "min-width": _vm.$utils.flexColumnWidth("实际消耗", true)
                }
              }),
              _vm._l(_vm.cyclicData, function(item, index) {
                return _c("el-table-column", {
                  key: "rois" + index,
                  attrs: {
                    prop: item.prop,
                    label: item.label,
                    "render-header": function(h, obj) {
                      return _vm.renderheader(h, obj, item.desc)
                    },
                    "min-width": _vm.$utils.flexColumnWidth(
                      item.tableText,
                      false
                    )
                  }
                })
              })
            ],
            2
          )
        : _vm._e(),
      _c("div", {
        staticClass: "margin-top",
        staticStyle: { height: "500px" },
        attrs: { id: "roiacdeEchart" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }